export default __webpack_public_path__ + "static/media/logo_ANZOR_small.2436d169.svg";